module.exports = __webpack_public_path__ + "fde2dd724cede412961bdafaffc148e9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cast_04.png
 ** module id = 241
 ** module chunks = 0
 **/